bcn.datepicker = (function () {

  'use strict';

  var dateRangeInputs= $('[data-date-range-picker] input');

  function initDatePicker () {

    var startDateInput = dateRangeInputs.first();
    var endDateInput = dateRangeInputs.last();

    dateRangeInputs.each(function() {
      $(this).datepicker({
        autoclose: true,
        format: 'dd/mm/yyyy',
        startDate: new Date()
      });
    });

    startDateInput.on('changeDate', function (e) {
      var endDate = endDateInput.datepicker('getDate');

      if (e.date > endDate) {
        endDateInput.datepicker('update', e.date);
      }
      endDateInput.datepicker('setStartDate', e.date);

    });
  }

  return {
    init: function () {
      initDatePicker();
    }
  };

})();
